// extracted by mini-css-extract-plugin
module.exports = {"btn_radius":"FJButtonSemicircle_btn_radius__Hm7nW"};